import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

const initialState = {
  urls: []
}

const reducers = function calls(state = { ...initialState }, action) {
  // let config = { ...state.config };
  switch (action.type) {
    case "SET_USER":
      return { ...state, user: action.user };
    case "SET_URLS":
      return { ...state, urls: action.urls };
    // case "SET_PRODUCTS":
    //   config.products = action.products;
    //   return { ...state, config };
    // case "SET_COLLECTIONS":
    //   config.collections = action.collections;
    //   return { ...state, config };
    default:
      return state;
  }
};

export default history =>
  combineReducers({
    router: connectRouter(history),
    reducers
  });
